import CardContainer from "./cardcontainer";

const HtmlPost = ({ post, ...props }) => {
  return (
    <CardContainer
      id={post.hid}
      className="p-4 overflow-auto"
      style={{
        backgroundColor: post?.background_color
          ? post.background_color
          : "#333333",
      }}
      {...props}
    >
      <div
        className="w-full h-full"
        dangerouslySetInnerHTML={{ __html: post.html_content }}
      />
    </CardContainer>
  );
};

export default HtmlPost;
